// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  padding: 24px 20px;
  background-color: white;
  border: 1px solid var(--space-gray);
  border-radius: 8px;
}

.accordion .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.accordion .title svg {
  transition: transform 0.2s;
}

.accordion:not(.hidden) .title svg {
  transform: rotate(180deg);
}

.accordion .title span {
  font-size: 16px;
  font-weight: 500;
  line-height: 130%;
}

.accordion .body {
  color: var(--dark-gray);
  font-size: 16px;
  font-weight: 400;
  line-height: 130%;

  max-height: 200px;
  overflow: hidden;
  transition: max-height 0.2s ease-out, padding 0.2s ease-out;
  padding-top: 12px;
}
.accordion.hidden .body {
  max-height: 0;
  padding-top: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/components/components.accordion.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,iBAAiB;EACjB,gBAAgB;EAChB,2DAA2D;EAC3D,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".accordion {\n  padding: 24px 20px;\n  background-color: white;\n  border: 1px solid var(--space-gray);\n  border-radius: 8px;\n}\n\n.accordion .title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.accordion .title svg {\n  transition: transform 0.2s;\n}\n\n.accordion:not(.hidden) .title svg {\n  transform: rotate(180deg);\n}\n\n.accordion .title span {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 130%;\n}\n\n.accordion .body {\n  color: var(--dark-gray);\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 130%;\n\n  max-height: 200px;\n  overflow: hidden;\n  transition: max-height 0.2s ease-out, padding 0.2s ease-out;\n  padding-top: 12px;\n}\n.accordion.hidden .body {\n  max-height: 0;\n  padding-top: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
